import { GET_SUBVENDOR_LIST, GET_SUBVENDOR_DETAILS, GET_ADDSUBVENDOR, GET_UPDATESUBVENDOR} from "resources/actionTypes";


const initialState = {
  userSubVendor: [],
  loading: false,
  error: null,
};
const initialStateAdd = {
  userAddSubVendor: [],
  loading: false,
  error: null,
};
const initialStateUpdate = {
  userUpdateSubVendor: [],
  loading: false,
  error: null
}
const initialStateDetail = {
  userDetailSubVendor: [],
  loading: false,
  error: null
}


export function userSubVendor(state = initialState, action) {
  switch (action.type) {
    case GET_SUBVENDOR_LIST.GET_SUBVENDOR_LIST_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_SUBVENDOR_LIST.GET_SUBVENDOR_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        userSubVendor: action.userSubVendor,
      };
    case GET_SUBVENDOR_LIST.GET_SUBVENDOR_LIST_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userAddSubVendor(state = initialStateAdd, action) {
  switch (action.type) {
    case GET_ADDSUBVENDOR.GET_ADDSUBVENDOR_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ADDSUBVENDOR.GET_ADDSUBVENDOR_SUCCESS:
      return {
        ...state,
        loading: false,
        userAddSubVendor: action.userAddSubVendor,
      };
    case GET_ADDSUBVENDOR.GET_ADDSUBVENDOR_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userUpdateSubVendor(state = initialStateUpdate, action) {
  switch (action.type) {
    case GET_UPDATESUBVENDOR.GET_UPDATESUBVENDOR_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_UPDATESUBVENDOR.GET_UPDATESUBVENDOR_SUCCESS:
      return {
        ...state,
        loading: false,
        userUpdateSubVendor: action.userUpdateSubVendor,
      };
    case GET_UPDATESUBVENDOR.GET_UPDATESUBVENDOR_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userDetailSubVendor(state = initialStateDetail, action) {
  switch (action.type) {
    case GET_SUBVENDOR_DETAILS.GET_SUBVENDOR_DETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_SUBVENDOR_DETAILS.GET_SUBVENDOR_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        userDetailSubVendor: action.userDetailSubVendor,
      };
    case GET_SUBVENDOR_DETAILS.GET_SUBVENDOR_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
